import {MENU_SEARCH_LIST_RELOAD} from '../actionType';

export default function (displayFlag) {
    return {
        type: MENU_SEARCH_LIST_RELOAD,
        keyword: displayFlag


    }
}